import React, {useMemo, useState} from 'react';
import {Offcanvas} from "react-bootstrap";
import UserMainDrawer from "./UserMainDrawer";
import UserEditDrawer from "./UserEditDrawer";
import UserDeleteDrawer from "./UserDeleteDrawer";
import DrawerVouchers from "../DrawerVouchers/DrawerVouchers";
import {useTranslation} from "react-i18next";
import {ReactComponent as BackSVG} from "../../../../images/icons/arrow-left.svg";

interface Props {
    onHide: () => void;
    show: boolean;
    page?: string;
}

const UserDrawer = ({onHide, show, page}: Props) => {
    const [currentPage, setCurrentPage] = useState(page ?? "LOGIN");
    const {t} = useTranslation();

    const renderView = useMemo(() => {
        switch (currentPage) {
            case "delete":
                return <UserDeleteDrawer setPage={setCurrentPage} onHide={onHide}/>
            case "edit":
                return <UserEditDrawer setPage={setCurrentPage} onHide={onHide}/>
            case "vouchers":
                return <DrawerVouchers hideCouponBox onHide={() => setCurrentPage('')} show={currentPage === 'vouchers'} customHeader={
                    <div className={"user-header-top top"}>
                        <button onClick={() => setCurrentPage('')} className={"btn-back"} aria-label={t("common.action.back")}>
                            <BackSVG aria-hidden="true" />
                        </button>
                        <h3>
                            {t("modules.navbar.field.vouchers.title")}
                        </h3>
                    </div>
                }/>
            default:
                return <UserMainDrawer setPage={setCurrentPage} onHide={onHide}/>
        }
    }, [currentPage])

	return (
        <Offcanvas placement={"end"} show={show} onHide={onHide} className={`drawer user-drawer ${currentPage === "LOGIN" || !currentPage ? 'without-padding' : ""}`}>
            <Offcanvas.Body>
                {renderView}
            </Offcanvas.Body>
        </Offcanvas>
	)
}

export default UserDrawer;